import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ticker-card',
    templateUrl: './ticker-card.component.html',
    styleUrl: './ticker-card.component.scss',
    standalone: false
})
export class TickerCardComponent {
  @Input() titleText!: string;
  @Input() value!: string | number;
  @Input() isPercentageValue: boolean = false;
  @Input() changePercentage!: number;
  @Input() icon!: string;
  @Input() tone?: 'warning' | 'info';
  @Input() contentClass: string | null = null;

  abs(value: number): number {
    return Math.abs(value);
  }

  getIconClass = () => this.tone || (this.changePercentage > 0 ? 'positive' : 'negative');
}
